/* -----------------------------------
   COLOR SWITCH CLICK
----------------------------------- */
document.addEventListener('click', function (e) {
  const link = e.target.closest('.js-similar-color,.js-fit-link');
  if (!link) return;

  e.preventDefault();

  const handle = link.dataset.handle;
  if (!handle) return;

  loadProductViaSections(handle, false);
});


/* -----------------------------------
   MAIN AJAX PRODUCT + META LOADER
----------------------------------- */
async function loadProductViaSections(handle, fromPopState = false) {
  try {
    const mainProductContainer = document.querySelector('[data-section]');
    const sectionId = mainProductContainer?.dataset.section;

    const EDITORIAL_SECTION_TYPE = 'editorial-image-with-text';
    const EDITORIAL_SECTION_ID = 'editorial_image_with_text_V3frg3';

    if (!sectionId || !mainProductContainer) {
      window.location.href = `/products/${handle}`;
      return;
    }

    /* START: Custom Code for Perfectly Paired With (PPW) */
    const currentPpwWrapper = document.querySelector('[id*="perfectly-paired"] .paired-section-wrapper');
    if (currentPpwWrapper) {
      currentPpwWrapper.style.display = 'block';
      const cardsContainer = currentPpwWrapper.querySelector('.paired-cards-container');
      if (cardsContainer) {
        cardsContainer.innerHTML = `
          <div class="paired-skeleton-card">
            <div class="paired-skeleton-image">&nbsp;</div>
            <div class="paired-skeleton-info">
              <div class="paired-skeleton-line paired-skeleton-line-1"> </div>
              <div class="paired-skeleton-line paired-skeleton-line-2"> </div>
              <div class="paired-skeleton-line paired-skeleton-line-3"> </div>
              <div class="paired-skeleton-line paired-skeleton-line-4"> </div>
            </div>
          </div>
          <div class="paired-plus-sign">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.0312 6.03125H6.96875V0.96875C6.96875 0.709859 6.75889 0.5 6.5 0.5C6.24111 0.5 6.03125 0.709859 6.03125 0.96875V6.03125H0.96875C0.709859 6.03125 0.5 6.24111 0.5 6.5C0.5 6.75889 0.709859 6.96875 0.96875 6.96875H6.03125V12.0312C6.03125 12.2901 6.24111 12.5 6.5 12.5C6.75889 12.5 6.96875 12.2901 6.96875 12.0312V6.96875H12.0312C12.2901 6.96875 12.5 6.75889 12.5 6.5C12.5 6.24111 12.2901 6.03125 12.0312 6.03125Z" fill="#1A1A1A" stroke="black"></path></svg>
          </div>
          <div class="paired-skeleton-card">
            <div class="paired-skeleton-image">&nbsp;</div>
            <div class="paired-skeleton-info">
              <div class="paired-skeleton-line paired-skeleton-line-1"> </div>
              <div class="paired-skeleton-line paired-skeleton-line-2"> </div>
              <div class="paired-skeleton-line paired-skeleton-line-3"> </div>
              <div class="paired-skeleton-line paired-skeleton-line-4"> </div>
            </div>
          </div>
          <div class="paired-plus-sign">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.0312 6.03125H6.96875V0.96875C6.96875 0.709859 6.75889 0.5 6.5 0.5C6.24111 0.5 6.03125 0.709859 6.03125 0.96875V6.03125H0.96875C0.709859 6.03125 0.5 6.24111 0.5 6.5C0.5 6.75889 0.709859 6.96875 0.96875 6.96875H6.03125V12.0312C6.03125 12.2901 6.24111 12.5 6.5 12.5C6.75889 12.5 6.96875 12.2901 6.96875 12.0312V6.96875H12.0312C12.2901 6.96875 12.5 6.75889 12.5 6.5C12.5 6.24111 12.2901 6.03125 12.0312 6.03125Z" fill="#1A1A1A" stroke="black"></path></svg>
          </div>
          <div class="paired-skeleton-card">
            <div class="paired-skeleton-image">&nbsp;</div>
            <div class="paired-skeleton-info">
              <div class="paired-skeleton-line paired-skeleton-line-1"> </div>
              <div class="paired-skeleton-line paired-skeleton-line-2"> </div>
              <div class="paired-skeleton-line paired-skeleton-line-3"> </div>
              <div class="paired-skeleton-line paired-skeleton-line-4"> </div>
            </div>
          </div>
        `;
      }
    }
    /* END: Custom Code for Perfectly Paired With (PPW) */

    /* -----------------------------
       FETCH ALL REQUIRED SECTIONS
    --------------------------------*/
    /* START: Custom Code for You May Also Like (YMAL) & Perfectly Paired With (PPW) */
    const res = await fetch(
      `/products/${handle}?sections=${sectionId},${EDITORIAL_SECTION_TYPE},you-may-also-like,perfectly-paired-dynamic`,
      { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
    );
    /* END: Custom Code for You May Also Like (YMAL) & Perfectly Paired With (PPW) */

    const sectionsJson = await res.json();

    /* -----------------------------
       UPDATE MAIN PRODUCT SECTION
    --------------------------------*/
    if (sectionsJson[sectionId]) {
      const doc = new DOMParser().parseFromString(
        sectionsJson[sectionId],
        'text/html'
      );
      const newMainNode = doc.body.firstChild;

      if (newMainNode) {
        mainProductContainer.replaceWith(newMainNode);

        if (!fromPopState) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          requestAnimationFrame(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          });
        }

        // Reset scroll position for image galleries to prevent browser scroll anchoring
        const newMain = document.querySelector(`[data-section="${sectionId}"]`);
        if (newMain) {
          const sliders = newMain.querySelectorAll('[id^="Slider-"]');
          sliders.forEach(slider => {
            slider.scrollLeft = 0;
          });
        }
      }
    } else {
      window.location.href = `/products/${handle}`;
      return;
    }
    /* -----------------------------
   UPDATE META / EDITORIAL SECTION
    --------------------------------*/
    // 1. Identify the existing section on the page
    const currentEditorial = document.querySelector(`[data-section-id="${EDITORIAL_SECTION_ID}"], .shopify-section[id*="${EDITORIAL_SECTION_TYPE}"], #AjaxImageWithText`);

    const rawHtml = sectionsJson[EDITORIAL_SECTION_TYPE];

    if (rawHtml) {
      const doc = new DOMParser().parseFromString(rawHtml, 'text/html');

      // 2. STRICTOR CHECK: Look for the specific "Row" class that contains your data
      // If this class is missing, it means the metafield is empty
      const hasData = doc.querySelector('.image-text-row') !== null;
      const newNode = doc.querySelector('.shopify-section') || doc.body.firstElementChild;

      if (hasData && newNode) {
        if (currentEditorial) {
          currentEditorial.replaceWith(newNode);
        } else {
          insertMetaSection(newNode);
        }
      } else {
        // 3. FORCE REMOVE: If the AJAX response has no 'image-text-row', 
        // the previous product's section MUST be deleted.
        if (currentEditorial) {
          currentEditorial.remove();
        }
      }
    } else {
      // 4. ABSOLUTE FALLBACK: If Shopify returns nothing at all
      if (currentEditorial) {
        currentEditorial.remove();
      }
    }
    /* START: Custom Code for You May Also Like (YMAL) */
    const currentYouMayAlsoLike = document.getElementById('shopify-section-you-may-also-like') || document.querySelector('.shopify-section[id*="you-may-also-like"]');
    if (currentYouMayAlsoLike && sectionsJson['you-may-also-like']) {
      const doc = new DOMParser().parseFromString(sectionsJson['you-may-also-like'], 'text/html');
      const newNode = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
      if (newNode) {
        currentYouMayAlsoLike.replaceWith(newNode);
        // Execute the script inside the newly loaded section to run recommendations for the new fit
        newNode.querySelectorAll('script').forEach(oldScript => {
          const newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach(attr => {
            newScript.setAttribute(attr.name, attr.value);
          });
          newScript.appendChild(document.createTextNode(oldScript.innerHTML));
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      }
    }
    /* END: Custom Code for You May Also Like (YMAL) */
    /* START: Custom Code for Perfectly Paired With (PPW) */
    const currentPerfectlyPaired = document.getElementById('shopify-section-perfectly-paired-dynamic') || document.querySelector('.shopify-section[id*="perfectly-paired-dynamic"]');
    if (currentPerfectlyPaired && sectionsJson['perfectly-paired-dynamic']) {
      const doc = new DOMParser().parseFromString(sectionsJson['perfectly-paired-dynamic'], 'text/html');
      const newNode = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
      if (newNode) {
        currentPerfectlyPaired.replaceWith(newNode);
        // Force display block to show skeletons during script loading
        const wrapper = newNode.querySelector('.paired-section-wrapper');
        if (wrapper) {
          wrapper.style.display = 'block';
        }
        // Execute the script inside the newly loaded section to run recommendations for the new fit
        newNode.querySelectorAll('script').forEach(oldScript => {
          const newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach(attr => {
            newScript.setAttribute(attr.name, attr.value);
          });
          newScript.appendChild(document.createTextNode(oldScript.innerHTML));
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      }
    }
    /* END: Custom Code for Perfectly Paired With (PPW) */
    /* -----------------------------
       PUSH HISTORY (ONLY ON CLICK)
    --------------------------------*/
    if (!fromPopState) {
      history.pushState(
        { handle },
        '',
        `/products/${handle}`
      );
    }

    /* -----------------------------
       RE-INITIALIZE SHOPIFY JS
    --------------------------------*/
    setTimeout(() => {
      document.dispatchEvent(new Event('shopify:section:load'));
      reInitAfterAjax();
    }, 50);

  } catch (err) {
    console.error('AJAX Product Load Error:', err);
    window.location.href = `/products/${handle}`;
  }
}


/* -----------------------------------
   META SECTION INSERT POSITION
----------------------------------- */
function insertMetaSection(newMeta) {
  const anchor =
    document.querySelector('#AjaxProductExtra') ||
    document.querySelector('.custom-main-product') ||
    document.querySelector('product-info');

  if (anchor) {
    anchor.appendChild(newMeta);
  }
}


/* -----------------------------------
   RE-INIT AFTER AJAX LOAD
----------------------------------- */
function reInitAfterAjax() {

  // Mobile product media swiper
  if (typeof window.initMobileSwiper === 'function') {
    window.initMobileSwiper();
    setTimeout(() => {
      window.initMobileSwiper();
    }, 50);
  }

  // Similar color swiper
  if (typeof window.initSimilarColorSwiper === 'function') {
    window.initSimilarColorSwiper();
    setTimeout(() => {
      window.initSimilarColorSwiper();
    }, 50);
  } else if (typeof initSimilarColorSwiper === 'function') {
    initSimilarColorSwiper();
  }

  // Product drawers
  if (typeof initProductDrawers === 'function') {
    initProductDrawers();
  }
  if (typeof initSizeGuide === 'function') {
    initSizeGuide();
  }
  /* ===== Custom Code Start (Re-initialize magnifier lens after AJAX load) ===== */
  if (typeof window.initMagnifierLens === 'function') {
    window.initMagnifierLens();
  }
  /* ===== Custom Code End ===== */
  /* ===== Custom Code Start (Re-initialize desktop sticky ATC after AJAX load) ===== */
  if (typeof window.initStickyAtcBar === 'function') {
    window.initStickyAtcBar();
  }
  /* ===== Custom Code End ===== */
  // Dawn / variant safety
  document.querySelectorAll('variant-selects').forEach(el => {
    el.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ===== Custom Code Start (Force GoKwik Buy It Now button to become active if it gets stuck after AJAX) ===== */
  setTimeout(() => {
    const gokwikBtn = document.querySelector('#gokwik-buy-now');
    if (gokwikBtn) {
      // Remove disabled state
      gokwikBtn.removeAttribute('disabled');
      gokwikBtn.classList.remove('disabled');

      // Hide any stuck GoKwik loader inside the button
      const loader = gokwikBtn.querySelector('.addloadr');
      if (loader) {
        loader.style.setProperty('display', 'none', 'important');
      }

      // Ensure button text is visible
      const btnText = gokwikBtn.querySelector('.btn-text');
      if (btnText) {
        btnText.style.display = '';
      }
    }
  }, 2000);
  /* ===== Custom Code End ===== */

  /* ===== Custom Code Start (Trigger scroll event for mobile-sticky button after AJAX) ===== */
  window.dispatchEvent(new Event('scroll'));
  /* ===== Custom Code End ===== */
}


/* -----------------------------------
   BACK / FORWARD BROWSER SUPPORT
----------------------------------- */
window.addEventListener('popstate', function (e) {
  if (e.state?.handle) {
    loadProductViaSections(e.state.handle, true);
  } else {
    // Fallback safety
    location.reload();
  }
});